import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { ButtonMode, IconPosition } from '@fcom/ui-components';
import { CmsContent, CMSelectionRules } from '@fcom/core-api';
import { FragmentService } from '@fcom/common';
import { LoginService } from '@fcom/common/login';
import { AppState } from '@fcom/core';
import { LoginStatus } from '@fcom/core-api/login';
import { loginStatus } from '@fcom/core/selectors';
import { finShare } from '@fcom/rx';
import { stopPropagation } from '@fcom/utils';

import { HelpButtonStatus } from '../../interfaces';

@Component({
  selector: 'fin-pre-chat',
  templateUrl: 'pre-chat.component.html',
  styleUrls: ['pre-chat.component.scss'],
})
export class PreChatComponent implements OnInit {
  readonly chatExpandKey = 'chat-expand';
  readonly HelpButtonStatus = HelpButtonStatus;
  readonly IconPosition = IconPosition;
  readonly LoginStatus = LoginStatus;
  readonly ButtonMode = ButtonMode;

  @Output()
  chatToggle: EventEmitter<HelpButtonStatus> = new EventEmitter();

  @Output()
  startChat: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('minimize', { static: false })
  minimizeButton: ElementRef;

  availableAccordions$: Observable<CmsContent[]>;
  loginStatus$: Observable<LoginStatus>;

  constructor(
    private fragmentService: FragmentService,
    private store$: Store<AppState>,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.availableAccordions$ = this.fragmentService
      .getFragment<CMSelectionRules>('fragments.chatPreScreen.url')
      .pipe(map((collection) => collection.items));
    setTimeout(() => {
      this.minimizeButton.nativeElement.focus();
    }, 0);

    this.loginStatus$ = this.store$.pipe(loginStatus(), finShare());
  }

  handleLogin = (e: MouseEvent) => {
    stopPropagation(e);

    this.loginService.redirectToLogin();
  };
}
